import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { TeamConfigurationComponent } from '../../TeamSettings/TeamConfiguration';
import { handleTeamSettingsModalProps } from '../teamTableTypes';

export default function TeamEditModal({
  isOpen,
  teamName,
  handleTeamSettingsModal,
  onClose,
}: {
  teamName: string;
  isOpen: boolean;
  handleTeamSettingsModal?: handleTeamSettingsModalProps;
  onClose: () => void;
}) {
  const [refetchData, setRefetchData] = useState(false);
  const queryClient = useQueryClient();
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (refetchData) queryClient.invalidateQueries(['goalsTeamTableData']);
        setRefetchData(false);
        onClose();
        handleTeamSettingsModal?.onClose();
      }}
      scrollBehavior="inside"
      isCentered
    >
      <ModalOverlay />
      <ModalContent maxW="1200px" minH={650}>
        <ModalHeader>Update Team: {teamName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TeamConfigurationComponent
            teamNameProp={teamName}
            setRefetchData={setRefetchData}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
